import { Component, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { ContactSearchVM } from '../services/api';
import { AppStateService } from '../services/app-state.service';
import { JwtAuthService } from '../services/jwt-auth.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit {
  userName: string = "";
  noramalColor = "#4F94D3";
  showContactMenu = false;
  showProgramsMenu = false;
  collapsMainMenu = false;
  constructor(private auth2:JwtAuthService,public appState:AppStateService,private auth:AuthService) { }

  ngOnInit(): void {
    this.appState.user$.subscribe(obj=>{
      this.userName = obj.firstName + " " + obj.lastName;

    })

  }

  logout() {
    this.auth.logout({ returnTo: document.location.origin })
    this.appState.setUser(<ContactSearchVM>{});
    //this.auth.signout();
  }
  showContactMenuaction() {
    this.showContactMenu = !this.showContactMenu;
  


  }
  showProgramsMenuaction() {
  this.showProgramsMenu = !this.showProgramsMenu;
}
  collapsMainMenuaction() {
    this.collapsMainMenu = !this.collapsMainMenu;
  }
}
